export default __webpack_public_path__ + "static/proveedores-a12e70879e3936aec23ae47dd557d06e.png";